module.exports = __webpack_public_path__ + "img/full1-min.36666ce4.png";